import { render, staticRenderFns } from "./ModalInviteAdmin.vue?vue&type=template&id=7836360a"
import script from "./ModalInviteAdmin.vue?vue&type=script&lang=js"
export * from "./ModalInviteAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalInviteAdmin.vue?vue&type=style&index=0&id=7836360a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports